import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {Melody} from "../../model/melody";
import {Tag} from "../../model/tag";
import {ContentService} from "../../services/content.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DeviceService} from "../../services/device.service";
import {constants} from "../../constants";
import {ClassService} from "../../services/class.service";
import {MainPageBanner} from "../../model/main-page-banner";

declare var $: any;

@Component({
  selector: 'app-genres-page',
  templateUrl: './genres-page.component.html',
  styleUrls: ['./genres-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class GenresPageComponent implements OnInit, OnDestroy {
  tagId: number;
  selectedTag: Tag;
  tags: ReadonlyArray<Tag>;

  hitsMelodies: ReadonlyArray<Melody>;

  melodies: Melody[];
  melodiesCount: number;

  page: number;
  pageSize: number;
  sort: string;
  asc: boolean;
  sortByTitle: boolean;

  countLoadSubscription: Subscription;
  loadSubscription: Subscription;
  loadInProgress: boolean;
  mainPageSpecialBanners: ReadonlyArray<MainPageBanner>;

  subscription: Subscription;

  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router,
              private readonly contentService: ContentService,
              readonly deviceService: DeviceService,
              private readonly classService: ClassService) {
    this.tagId = null;
    this.selectedTag = null;
    this.tags = [];

    this.hitsMelodies = [];
    this.mainPageSpecialBanners = [];

    this.melodies = [];
    this.melodiesCount = 0;
    this.page = 0;
    this.pageSize = deviceService.genresPageMelodiesSize;
    this.sortByTitle = false;
    this.sort = 'likes';
    this.asc = false;

    this.countLoadSubscription = null;
    this.loadSubscription = null;
    this.loadInProgress = false;

    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.contentService.tagsList.subscribe(value => {
        this.tags = value;
        this.loadData();
      })
    );

    this.subscription.add(
      this.contentService.hitsMelodies.subscribe(value => this.hitsMelodies = value)
    );

    this.subscription.add(
      this.contentService.mainPageSpecialBanners.subscribe(banners => this.mainPageSpecialBanners = banners)
    )

    this.subscription.add(
      this.route.queryParams.subscribe(params => {
        this.selectedTag = null;
        this.tagId = parseInt(params['id']);
        this.loadData();
      }));
  }

  loadData(): void {
    if (!this.selectedTag && this.tagId && this.tags?.length > 0) {
      this.selectedTag = this.tags.find(item => item.id == this.tagId);

      if (!this.selectedTag) {
        this.router.navigate(['error', '404']);
      }
    }

    this.loadMelodies();
  }

  loadMelodies(): void {
    this.page = 0;
    this.melodies = [];
    this.melodiesCount = 0;
    this.loadInProgress = false;

    if (this.countLoadSubscription) {
      this.countLoadSubscription.unsubscribe();
      this.countLoadSubscription = null;
    }

    if (this.loadSubscription) {
      this.loadSubscription.unsubscribe();
      this.loadSubscription = null;
    }

    this.countLoadSubscription = (this.tagId ? this.contentService.getTagMelodiesCount(this.tagId) : this.contentService.getAllMelodiesCount())
      .subscribe(count => {
        this.melodiesCount = count;
      });

    this.loadMelodiesPage();
  }

  loadMelodiesPage(): void {
    if (!this.loadInProgress && (this.melodies.length < this.melodiesCount || this.page == 0)) {
      this.loadInProgress = true;

      this.loadSubscription = (this.tagId ? this.contentService.getTagMelodies(this.tagId, this.page, this.pageSize, this.sort, this.asc) :
                                            this.contentService.getAllMelodies(this.page, this.pageSize, this.sort, this.asc))
        .subscribe((melodies) => {
          this.melodies = this.melodies.concat(melodies);
          this.page++
          this.loadInProgress = false;
          this.loadSubscription = null;
        });
    }
  }

  openTag(tagId: number): void {
    this.router.navigate(['genres'], {queryParams: {id: tagId}, skipLocationChange: true })
  }

  openAll(): void {
    this.router.navigate(['genres'], {skipLocationChange: true })
  }

  changeSort(sortByTitle: boolean): void {
    this.sortByTitle = sortByTitle;
    if (sortByTitle) {
      this.sort = "melody.title";
      this.asc = true;
    } else {
      this.sort = 'likes';
      this.asc = false;
    }
    this.loadData()
  }

  rightScroll(): void {
    this.scrollTabs(constants.genresScrollWidth);
  }

  leftScroll(): void {
    this.scrollTabs(-constants.genresScrollWidth);
  }

  scrollTabs(width: number): void {
    let $pageTabs = $(".page-tabs");
    let currentScroll = $pageTabs.scrollLeft();
    let newScroll = currentScroll + width;

    $pageTabs.animate({ scrollLeft: newScroll }, 200, this.updateArrows);
  }

  updateArrows(): void {
    let $pageTabs = $(".page-tabs");
    let maxScrollLeft = $pageTabs.get(0).scrollWidth - $pageTabs.innerWidth();
    let currentScroll = $pageTabs.scrollLeft();

    $(".page-tabs__prev").toggleClass(
      "page-tabs__arrow-disabled",
      currentScroll <= 0
    );
    $(".page-tabs__next").toggleClass(
      "page-tabs__arrow-disabled",
      currentScroll >= maxScrollLeft
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getIconClass(tag: Tag) {
    return this.classService.getIconClass(tag)
  }
}
